import { render, staticRenderFns } from "./Toggler.vue?vue&type=template&id=72faa86f&scoped=true"
import script from "./Toggler.vue?vue&type=script&lang=js"
export * from "./Toggler.vue?vue&type=script&lang=js"
import style0 from "./Toggler.vue?vue&type=style&index=0&id=72faa86f&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72faa86f",
  null
  
)

export default component.exports